<template>
  <div class="access-denied-container">
    <div class="access-denied-card">
      <div class="icon-container">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h1>Embed Access Denied</h1>
      <p class="error-message">
        This content can only be embedded on authorized domains.
      </p>
      <div class="details" v-if="attemptedDomain && attemptedDomain !== 'unknown'">
        <p class="detail-label">Attempted from:</p>
        <p class="detail-value">{{ attemptedDomain }}</p>
      </div>
      <div class="info-box">
        <i class="fas fa-info-circle"></i>
        <p>If you believe this is an error, please contact support at <a href="mailto:support@gridrank.com">support@gridrank.com</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmbedAccessDenied',
  computed: {
    attemptedDomain() {
      return this.$route.query.attempted || 'unknown';
    },
    reason() {
      return this.$route.query.reason || 'unauthorized';
    }
  }
}
</script>

<style scoped>
.access-denied-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #19233A;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.access-denied-card {
  background: white;
  border-radius: 12px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
}

.icon-container {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-container i {
  font-size: 40px;
  color: white;
}

h1 {
  font-size: 28px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 12px;
}

.error-message {
  font-size: 16px;
  color: #4a5568;
  margin-bottom: 30px;
  line-height: 1.6;
}

.details {
  background: #f7fafc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  border: 1px solid #e2e8f0;
}

.detail-label {
  font-size: 12px;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 8px;
}

.detail-value {
  font-size: 14px;
  color: #2d3748;
  font-family: 'Courier New', monospace;
  word-break: break-all;
  background: white;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.info-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #edf2f7;
  padding: 16px;
  border-radius: 8px;
  text-align: left;
}

.info-box i {
  color: #4299e1;
  font-size: 18px;
  flex-shrink: 0;
  margin-top: 2px;
}

.info-box p {
  font-size: 14px;
  color: #2d3748;
  margin: 0;
  line-height: 1.5;
}

.info-box a {
  color: #4299e1;
  text-decoration: none;
  font-weight: 500;
}

.info-box a:hover {
  text-decoration: underline;
}

@media (max-width: 640px) {
  .access-denied-card {
    padding: 30px 20px;
  }

  h1 {
    font-size: 24px;
  }

  .error-message {
    font-size: 14px;
  }
}
</style>